import querySelectorAll from 'utils/DOM/querySelectorAll'

function removeEventListenerBySelector(selector, event, callback) {
  const nodes = querySelectorAll(selector)

  for (let index = 0; index < nodes.length; index++) {
    const node = nodes[index]
    node.removeEventListener(event, callback)
  }
}

export default removeEventListenerBySelector
